import React from 'react';
import useErrorMessage from "./useErrorMessage";
import useLoading from "./useLoading";
import useInitialPath from "./useInitialPath";

export default function useAsyncErrorHandler(config = { showDetails: false }) {
    const showErrorMessage = useErrorMessage();
    const setLoading = useLoading();
    const initialPath = useInitialPath();

    return error => {
        const errorMessage = error.mensagem || error;
        let errorDetails = !!error.detalhe ? error.detalhe : '';
        errorDetails = !!error.dataHora
            ? !!error.usuario
                ? error.dataHora + ' por ' + error.usuario + ' -> ' + errorDetails
                : error.dataHora + ' -> ' + errorDetails
            : errorDetails;

        if ((initialPath === 'administrativo' || config.showDetails) && !!errorDetails) {
            showErrorMessage(errorMessage, errorDetails);
        } else {
            if (!!errorDetails) {
                console.log(errorDetails);
            }

            showErrorMessage(errorMessage);
        }

        setLoading(false);
    };
}